import { ClockCircleOutlined } from "@ant-design/icons";
import { Link } from "wouter";

export const SIDEBAR_ROUTES = [
  {
    key: "0",
    icon: <ClockCircleOutlined />,
    path: "/admin/warranties",
    label: <Link to="/admin/warranties">Warranties</Link>,
  },
  {
    key: "1",
    icon: <ClockCircleOutlined />,
    path: "/admin/qr-codes-ncr",
    label: <Link to="/admin/qr-codes-ncr">QR Codes NCR</Link>, // Fixed space in path
  },
  {
    key: "2",
    icon: <ClockCircleOutlined />,
    path: "/admin/qr-codes-ncr",
    label: <Link to="/admin/qr-codes-north">QR Codes North</Link>, // Fixed space in path
  },
  {
    key: "3",
    icon: <ClockCircleOutlined />,
    path: "/admin/qr-codes-ncr",
    label: <Link to="/admin/qr-codes-west">QR Codes West</Link>, // Fixed space in path
  },
];
